<p class="pr-small-b">{{ 'MMB.checkIn.funnel.steps.seats.message' | finLocalization }}</p>

<fin-ancillary-flight-bound-selector
  *ngIf="(flights$ | async).length > 1"
  class="pr-small-t mobile-bleed"
  [showFlightCard$]="true | finToObservable"
  [boundsOrFlights]="flights$ | async"
  [activeBoundIndex]="slideIndex$ | async"
  [passengers]="passengers$ | async"
  [locations]="order$ | finMap: 'locations' | async"
  (selectIndex)="slideIndex$.next($event)"
>
</fin-ancillary-flight-bound-selector>

<div class="overflow-hidden mobile-blee pr-small-t mr-large-b">
  <div class="slider relative nowrap fill slide-{{ slideIndex$ | async }}">
    <div
      *ngFor="let flight of flights$ | async; let i = index; trackBy: flightsTrackBy"
      class="inline-block valign-top fill"
    >
      <fin-ancillary-seat-map
        [flight]="flight"
        [passengers$]="passengers$"
        [cartOrOrder$]="order$"
        [seatSelections$]="seatSelections$"
        [flightIsActive$]="i === 0 | finToObservable"
        [includedSeats]="includedSeats$ | async"
        [availability$]="flightAncillaryAvailability$"
        [canClearSeats]="false"
        [preSelectedPax$]="selectedModifiedPax$"
        [ancillaryLoader$]="ancillaryLoader$"
        (retrySeatmap)="loadSeatMapForFlightFromOrder($event)"
        (changeSeats)="changeSeats($event)"
        (subtotalChange)="subtotalChange($event, flight.id)"
        (finishedReassigningSeats)="emitSwitchAncillaryLoaderOff($event)"
      >
      </fin-ancillary-seat-map>
    </div>
  </div>
</div>

<fcom-cta-button
  *finLet="ctaAction$ | async as ctaAction"
  [visible]="true"
  [loading]="updateInProgress$ | async"
  [title]="ctaAction.key | finLocalization"
  [position]="ButtonPosition.GRID_FULL"
  [theme]="(hasNextFlight$ | async) ? ButtonTheme.DARK_PRIMARY_NORDIC_BLUE : ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
  (buttonClicked)="continue(ctaAction.action)"
>
  <span class="gray-50-text">{{ 'subtotal' | finLocalization }}: </span>
  <span class="font-body-1">{{ subTotalPrice$ | async | finPrice | finEmpty: '&ndash;' }}</span>
  <ng-container *ngIf="checkInAssignSeatVisible$ | async">
    <div class="flex flex--column">
      <button data-testid="reassign-seat-button" class="underline" (click)="checkInAssignFreeSeats()">
        <b>{{ 'ancillaries.seats.reassignFreeSeat' | finLocalization }}</b>
        <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_BACK"></fcom-icon>
      </button>
    </div>
  </ng-container>
</fcom-cta-button>
